import { useState, useEffect } from 'react';
import { generateFAQSchema } from '../../../utils/seo';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'O que é o LBAs Essentials?',
      answer: 'O LBAs Essentials é um programa de consultoria de 10 a 12 meses focado em melhoria de processos para MEI e pequenas empresas. Oferecemos diagnóstico completo, implementação de melhorias e acompanhamento mensal para garantir resultados sustentáveis.',
    },
    {
      question: 'Quanto tempo dura o programa?',
      answer: 'O programa tem duração de 10 a 12 meses, dividido em módulos mensais. Cada módulo aborda aspectos específicos da gestão empresarial, desde diagnóstico inicial até automação e escalabilidade.',
    },
    {
      question: 'Qual o investimento mensal?',
      answer: 'O investimento é de R$ 497/mês, com possibilidade de desconto para pagamento anual. Este valor inclui diagnóstico completo, implementação de melhorias, acompanhamento mensal e acesso a todas as ferramentas e materiais do programa.',
    },
    {
      question: 'Como funciona o diagnóstico inicial?',
      answer: 'O diagnóstico inicial é gratuito e consiste em uma análise completa dos seus processos atuais. Identificamos gargalos, oportunidades de melhoria e criamos um plano personalizado para sua empresa.',
    },
    {
      question: 'Quais resultados posso esperar?',
      answer: 'Nossos clientes alcançam em média 40% de aumento na produtividade, redução de 30% em retrabalho e melhoria significativa na organização operacional. Os resultados variam conforme o engajamento e aplicação das metodologias.',
    },
    {
      question: 'O programa é adequado para meu tipo de negócio?',
      answer: 'O LBAs Essentials foi desenvolvido especificamente para MEI e pequenas empresas de diversos segmentos. Se você busca mais organização, produtividade e eficiência operacional, o programa é ideal para você.',
    },
    {
      question: 'Posso cancelar a qualquer momento?',
      answer: 'Sim, você pode cancelar sua participação a qualquer momento. Recomendamos completar pelo menos 3 meses para começar a ver resultados significativos, mas não há multa por cancelamento.',
    },
    {
      question: 'Como é o acompanhamento mensal?',
      answer: 'O acompanhamento inclui reuniões mensais de revisão, análise de indicadores, ajustes no plano de ação e suporte contínuo via WhatsApp. Você terá acesso direto aos consultores para tirar dúvidas e receber orientações.',
    },
  ];

  // Add FAQ Schema
  useEffect(() => {
    const faqSchema = generateFAQSchema(faqs);

    let script = document.querySelector('script[type="application/ld+json"]#faq-schema');
    if (!script) {
      script = document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      script.setAttribute('id', 'faq-schema');
      document.body.appendChild(script);
    }
    script.textContent = JSON.stringify(faqSchema);

    return () => {
      const existingScript = document.querySelector('script[type="application/ld+json"]#faq-schema');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#1e3a5f] mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-lg text-gray-600">
            Tire suas dúvidas sobre o programa
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-4 text-left flex items-center justify-between bg-white hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h4 className="text-lg font-semibold text-[#1e3a5f] pr-4">
                  {faq.question}
                </h4>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-[#e85d75] transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === index && (
                <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
                  <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
